'use client';

import { ComponentPropsWithoutRef, type FC } from 'react';
import { GemImage } from './GemImage';
import { NumberDiff } from '@wwe-portal/ui/components/text-diff';
import { cn } from '@wwe-portal/ui/lib/lib';

interface StatValue {
  value: number;
  comparedValue?: number;
}

export interface RosterStatsDetailsV2Props {
  stats: {
    Blue: StatValue;
    Black: StatValue;
    Yellow: StatValue;
    Purple: StatValue;
    Green: StatValue;
    Red: StatValue;
  };
}

const gemKeys = ['Black', 'Red', 'Blue', 'Green', 'Yellow', 'Purple'] as const;

export const RosterStatsDetailsV2: FC<
  ComponentPropsWithoutRef<'div'> & RosterStatsDetailsV2Props
> = ({ stats, className, ...props }) => {
  return (
    <div
      className={cn('w-full rounded-lg bg-[#191D3C] p-6 shadow-2xl', className)}
      {...props}
    >
      {/* Gems Grid */}
      <div className="grid grid-cols-3 gap-4 md:grid-cols-6">
        {gemKeys.map((gem) => (
          <div
            key={gem}
            className="text-blue600 flex flex-col items-center gap-2 font-semibold italic"
          >
            <GemImage gemKey={gem} className="size-16 lg:size-14 2xl:size-16" />
            <div className="h-10">
              <NumberDiff
                className="text-center"
                oldValue={stats[gem].comparedValue ?? stats[gem].value}
                newValue={stats[gem].value}
                showBaseDiff={false}
                diffOnNewLine
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
